import { getCartAvailability, withAirportNames } from '../../common/utils/availability';
export const getPurchasedCartAvailability = (buySpecification, bounds, numberOfTravelers, passLabel) => {
  var _segmentAvailabilitie;
  if ((buySpecification === null || buySpecification === void 0 ? void 0 : buySpecification.__typename) !== 'BuySpecificationCartLoungePerSegment') {
    return null;
  }
  const segments = ((_segmentAvailabilitie = buySpecification.segmentAvailabilities) !== null && _segmentAvailabilitie !== void 0 ? _segmentAvailabilitie : []).map(segment => {
    var _segment$departureAir;
    return {
      available: Boolean(segment.available),
      departureAirport: (_segment$departureAir = segment.departureAirport) !== null && _segment$departureAir !== void 0 ? _segment$departureAir : ''
    };
  });
  return getCartAvailability(numberOfTravelers, passLabel, withAirportNames(bounds, segments));
};
//# sourceMappingURL=getPurchasedCartAvailability.js.map